function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n    height: ", ";\n  "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1;\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", ";\n  pointer-events: none;\n  & > * {\n    pointer-events: auto;\n  }\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n          margin: -", "px;\n        "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n          ", ";\n          ", ";\n          top: ", "px;\n          left: ", "px;\n          ", ";\n        "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  overflow: hidden;\n  & > * {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  border-top-left-radius: ", "px;\n  border-top-right-radius: ", "px;\n  flex-shrink: 0;\n  overflow: hidden;\n  text-align: center;\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1;\n  transition: all 0.3s ease-in-out;\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n    width: 100vw;\n    max-width: ", ";\n    bottom: ", "px;\n  "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  left: 0;\n  right: 0;\n  margin: auto;\n  bottom: ", "px;\n  max-width: ", ";\n  width: calc(100vw - ", "px);\n  ", ";\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n    padding: ", "px ", "px;\n    flex-direction: column-reverse;\n    & > button:nth-child(2) {\n      margin: 0 0 ", "px 0;\n    }\n  "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n      & > * {\n        flex-grow: 1;\n        flex-shrink: 1;\n        flex-basis: 50%;\n      }\n    "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      & > button:nth-child(2) {\n        margin-left: ", "px;\n      }\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n      flex-direction: column-reverse;\n      & > button:nth-child(2) {\n        margin-bottom: ", "px;\n      }\n    "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: ", "px;\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: 'row';\n  ", ";\n  flex-shrink: 0;\n  overflow: hidden;\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: ", "px;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 0;\n  padding-bottom: 0;\n  ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n        padding-bottom: ", "px;\n      "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      padding-bottom: ", "px;\n      ", ";\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  z-index: 0;\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  background: ", ";\n  transition: all 0.2s ease-in-out;\n  z-index: 1;\n  ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      padding-top: ", "px;\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      padding-bottom: 0px;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  text-align: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    padding: ", "px ", "px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        box-shadow: 0px calc(", " * 1px) 0px rgba(0,0,0,0);\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        box-shadow: 0px calc(", " * 1px) 15px rgba(0,0,0,0.20);\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    max-width: ", ";\n    max-height: ", ";\n    height: ", ";\n    border-radius: ", ";\n    width: 100vw;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  background: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  max-width: ", ";\n  width: calc(100vw - ", "px);\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  -ms-overflow-y: scroll;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { BorderRadius, Inset, Media, Spacing } from '@doordash/design-language';
import { Layers, renderOnLayer } from '@doordash/component-layer-manager';
import { getMobileDevice, getMobileiOSBrowser, getiOSDeviceType } from './getEnvironmentConstants';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import { Sizes } from './constants';
import { get } from 'lodash';
var MODAL_PADDING = Inset.Sizes.Small;
var MOBILE_MODAL_PADDING = Inset.Sizes.Small;
var OS = getMobileDevice();
var BROWSER = getMobileiOSBrowser();
var IOS_DEVICE_TYPE = getiOSDeviceType();
var CHROME_PADDING = '34px';
var SAFARI_PADDING = '75px';

if (IOS_DEVICE_TYPE === 'TALL') {
  SAFARI_PADDING = '115px';
}

var getMobileHeight = function getMobileHeight() {
  // If we're on Android, we need to account for
  // the URL Bar Resizing behavior that's described
  // here: https://developers.google.com/web/updates/2016/12/url-bar-resizing
  // We're relying on the fact that position: fixed
  // elements have an exception in that it will
  // always fill the visible height, even if the URL bar
  // is showing or hiding.
  if (OS === 'Android') {
    return '100%';
  } // For iOS, we need to ensure that the height
  // of the full-screen modal accounts for the
  // height of the bottom navigation bar—otherwise
  // content would flow behind the bar and be
  // obscured (like the _primaryAction button_ which
  // would break the UX of the modal). So, we account
  // for this height on the tab bar and ensure all content
  // is always visible.


  if (OS === 'iOS' && BROWSER === 'Safari') {
    return "calc(100vh - ".concat(SAFARI_PADDING, ")");
  }

  if (OS === 'iOS' && BROWSER === 'Chrome' && IOS_DEVICE_TYPE === 'TALL') {
    return "calc(100vh - ".concat(CHROME_PADDING, ")");
  } // By default, just take up the entire viewport height.


  return '100vh';
};

var MOBILE_HEIGHT = getMobileHeight();

var getMaxWidthForSize = function getMaxWidthForSize(props) {
  var defaultMaxWidth = '768px';

  switch (props.size) {
    case Sizes.Custom:
      return "".concat(get(props.customSize, 'maxWidth') ? "".concat(props.customSize.maxWidth, "px") : defaultMaxWidth);

    case Sizes.FullScreen:
      return '100vw';

    case Sizes.XxLarge:
      return "calc(100vw - ".concat(MODAL_PADDING * 2, "px)");

    case Sizes.XLarge:
      return defaultMaxWidth;

    case Sizes.Large:
      return '560px';

    case Sizes.Medium:
      return '480px';

    case Sizes.Small:
    default:
      return '400px';
  }
};

var getHeightForSize = function getHeightForSize(props) {
  switch (props.size) {
    case Sizes.FullScreen:
      return '100vh';

    default:
      return '0';
  }
};

var getMaxHeightForSize = function getMaxHeightForSize(props) {
  var defaultMaxHeight = props.viewportHeight - MODAL_PADDING * 2;

  if (props.size === Sizes.Custom && get(props.customSize, 'maxHeight') && props.customSize.maxHeight <= defaultMaxHeight) {
    return "".concat(props.customSize.maxHeight, "px");
  }

  return "calc(100vh - ".concat(MODAL_PADDING * 2, "px)");
};

var getBorderRadiusForSize = function getBorderRadiusForSize(props) {
  switch (props.size) {
    case Sizes.FullScreen:
      return '0px';

    default:
      return "".concat(props.modalBorderRadius, "px");
  }
};

export var ModalContainer = styled.div(_templateObject(), function (props) {
  return props.modalBackgroundColor;
}, getHeightForSize, getMaxHeightForSize, getMaxWidthForSize, MODAL_PADDING * 2, getBorderRadiusForSize, Media.Mobile(_templateObject2(), function (props) {
  return props.isFullScreenOnMobile ? 'none' : "calc(100vw - ".concat(MOBILE_MODAL_PADDING, "px)");
}, function (props) {
  return props.isFullScreenOnMobile ? 'none' : "calc(100vh - ".concat(MOBILE_MODAL_PADDING, "px)");
}, function (props) {
  return props.isFullScreenOnMobile ? MOBILE_HEIGHT : "auto";
}, function (props) {
  return props.isFullScreenOnMobile ? BorderRadius.None : getBorderRadiusForSize(props);
}));

var showDivider = function showDivider(side) {
  return function (props) {
    return (// prettier-ignore
      props.showDivider ? css(_templateObject3(), side === 'top' ? -1 : 1) : css(_templateObject4(), side === 'top' ? -1 : 1)
    );
  };
};

var ConfiguredInset = function ConfiguredInset(_ref) {
  var hasPadding = _ref.hasPadding,
      props = _objectWithoutProperties(_ref, ["hasPadding"]);

  return React.createElement(Inset, _extends({
    size: hasPadding ? MODAL_PADDING : Inset.Sizes.None
  }, props));
};

ConfiguredInset.propTypes = {
  hasPadding: PropTypes.bool
};
export var ModalInset = styled(ConfiguredInset)(_templateObject5(), Media.Mobile(_templateObject6(), function (props) {
  return props.hasPadding ? MOBILE_MODAL_PADDING / 2 : 0;
}, function (props) {
  return props.hasPadding ? MOBILE_MODAL_PADDING : 0;
}));
ModalInset.defaultProps = {
  hasPadding: true
};
export var ModalContentHeader = styled.div(_templateObject7(), function (props) {
  return props.headerAlignment;
}); // When there's no modal content, we want
// to have no padding on the bottom of the header

export var ModalHeaderInset = styled(ModalInset).attrs({
  isSquished: true
})(_templateObject8(), function (props) {
  return !props.hasContent && css(_templateObject9());
});
export var ModalContentTitleContainer = styled.div(_templateObject10(), function (props) {
  return props.hasCloseButton && !props.hasHeaderImg && css(_templateObject11(), Spacing.XxLarge);
});
export var ModalStickyHeader = styled.div(_templateObject12(), function (props) {
  return props.modalBackgroundColor;
}, showDivider('bottom')); // This uses a div instead of `styled(ModalInset)`
// to make it easier to set the ref for the component

export var ModalContentContainer = styled.div(_templateObject13(), function (props) {
  return !props.hasFooter && props.hasPadding && css(_templateObject14(), MODAL_PADDING, Media.Mobile(_templateObject15(), MOBILE_MODAL_PADDING / 2));
});
export var ModalContent = styled(ModalInset).attrs({
  size: function size(props) {
    return props.hasPadding ? Inset.Sizes.Small : Inset.Sizes.None;
  },
  isSquished: true
})(_templateObject16(), Media.Mobile(_templateObject17(), function (props) {
  return props.hasPadding ? MOBILE_MODAL_PADDING / 2 : 0;
}));
export var ModalFooter = styled.div(_templateObject18(), function (props) {
  return props.modalBackgroundColor;
}, MODAL_PADDING, function (props) {
  return props.shouldStackButtons && css(_templateObject19(), Spacing.XSmall);
}, function (props) {
  return !props.shouldStackButtons && css(_templateObject20(), Spacing.Small);
}, showDivider('top'), function (props) {
  return props.actionsFillContainer && css(_templateObject21());
}, Media.Mobile(_templateObject22(), MOBILE_MODAL_PADDING / 2, MOBILE_MODAL_PADDING, Spacing.XSmall));
var FixedModalFooterContainer = styled.div(_templateObject23(), function (props) {
  return props.modalSize === Sizes.FullScreen ? '0' : MODAL_PADDING;
}, function (props) {
  return getMaxWidthForSize({
    size: props.modalSize
  });
}, MODAL_PADDING * 2, Media.Mobile(_templateObject24(), function (props) {
  return props.isFullScreenOnMobile ? 'none' : "calc(100vw - ".concat(MOBILE_MODAL_PADDING, "px)");
}, function (props) {
  return props.isFullScreenOnMobile ? '0' : MOBILE_MODAL_PADDING;
}));
export var InContentModalFooterContainer = styled.div(_templateObject25());
export var LayeredFooterContainer = renderOnLayer(Layers.PopoverModal, FixedModalFooterContainer);
export var ModalFooterContainer = function ModalFooterContainer(_ref2) {
  var isFooterFixedPosition = _ref2.isFooterFixedPosition,
      props = _objectWithoutProperties(_ref2, ["isFooterFixedPosition"]);

  return isFooterFixedPosition && OS === 'iOS' ? React.createElement(LayeredFooterContainer, props) : React.createElement(InContentModalFooterContainer, props);
};
ModalFooterContainer.propTypes = {
  isFooterFixedPosition: PropTypes.bool
};
ModalFooterContainer.defaultProps = {
  isFooterFixedPosition: false
};
export var ModalHeaderImage = styled.div(_templateObject26(), function (props) {
  return props.modalBorderRadius;
}, function (props) {
  return props.modalBorderRadius;
});
export var StickyTitle = styled.div(_templateObject27());
export var ModalCloseButtonContainer = styled.div(_templateObject28(), function (props) {
  return props.isFloating || props.hasCustomHeader ? css(_templateObject29(), props.isFloating && 'position: absolute', props.isFloating && 'z-index: 1', Inset.Sizes.XxSmall, Inset.Sizes.XxSmall, props.hasCustomHeader && "padding: ".concat(Inset.Sizes.XxxSmall, "px")) : css(_templateObject30(), Inset.Sizes.XxSmall);
});
export var FillScreen = styled.div(_templateObject31(), Media.Mobile(_templateObject32(), MOBILE_HEIGHT));
export var OverlayPositioner = styled.div(_templateObject33());